import { createAction, props } from '@ngrx/store'
import { FetchTasksParams, TaskResponse, TaskStatus, UpdateTaskPayload } from './task.model'
import { Update } from '@ngrx/entity'
import { CreateTaskPayload } from './task.model'

export const LoadTasks = createAction('[Task] Load Tasks', props<{ params?: FetchTasksParams }>())
export const LoadTasksComplete = createAction('[Task] Load Tasks Complete', props<{ tasks: TaskResponse[] }>())

export const LoadDraftTasks = createAction('[Task] Load Draft Tasks')
export const LoadDraftTasksComplete = createAction(
  '[Task] Load Draft Tasks Complete',
  props<{ tasks: TaskResponse[] }>()
)

// load by ids
export const LoadTasksByIds = createAction('[Task] Load Tasks by ids', props<{ ids: string[] }>())
export const LoadTasksByIdsComplete = createAction(
  '[Task] Load Tasks by ids Complete',
  props<{ tasks: TaskResponse[] }>()
)

export const LoadTasksByIncidentId = createAction('[Task] Load Tasks by incident id', props<{ incidentId: string }>())
export const LoadTasksByTriggerId = createAction('[Task] Load Tasks by trigger id', props<{ triggerId: string }>())
export const LoadTasksByUserIds = createAction('[Task] Load Tasks by user ids', props<{ userIds: string[] }>())
export const LoadTasksByInquiryIds = createAction('[Task] Load Tasks by inquiry ids', props<{ inquiryIds: string[] }>())

export const AddTask = createAction('[Task] Add Task', props<{ form: CreateTaskPayload }>())
export const AddTaskComplete = createAction('[Task] Add Task Complete', props<{ task: TaskResponse }>())

export const AddTasks = createAction('[Task] Add Tasks', props<{ requests: CreateTaskPayload[] }>())
export const AddTasksComplete = createAction('[Task] Add Tasks Complete', props<{ tasks: TaskResponse[] }>())

export const DeleteTask = createAction('[Task] Delete Task', props<{ id: string }>())
export const DeleteTaskComplete = createAction('[Task] Delete Task Complete', props<{ id: string }>())

export const DeleteTasks = createAction('[Task] Delete Tasks', props<{ ids: string[] }>())
export const DeleteTasksComplete = createAction('[Task] Delete Tasks Complete', props<{ ids: string[] }>())

export const UpdateTask = createAction('[Task] Update Task', props<{ form: UpdateTaskPayload; id: string }>())
export const UpdateTaskComplete = createAction('[Task] Update Task Complete', props<{ update: Update<TaskResponse> }>())

export const UpdateTasks = createAction('[Task] Update Tasks', props<{ form: UpdateTaskPayload; ids: string[] }>())
export const UpdateTasksComplete = createAction(
  '[Task] Update Tasks Complete',
  props<{ updates: Update<TaskResponse>[] }>()
)

export const ChangeTaskStatus = createAction('[Task] Change Status', props<{ status: TaskStatus; id: string }>())
export const ChangeTaskStatusComplete = createAction(
  '[Task] Change Status Complete',
  props<{ update: Update<TaskResponse> }>()
)

export const RejectTask = createAction('[Task] Reject Task', props<{ taskId: string }>())
export const RejectTaskComplete = createAction('[Task] Reject Task Complete', props<{ id: string }>())

export const ApproveTask = createAction('[Task] Approve Task', props<{ taskId: string }>())
export const ApproveTaskComplete = createAction(
  '[Task] Approve Task Complete',
  props<{ update: Update<TaskResponse> }>()
)

export const ArchiveTasks = createAction('[Task] Archive Tasks', props<{ ids: string[] }>())
export const ArchiveTasksComplete = createAction(
  '[Task] Archive Tasks Complete',
  props<{ updates: Update<TaskResponse>[] }>()
)

export const UnarchiveTasks = createAction('[Task] UnArchive Tasks', props<{ ids: string[] }>())
export const UnarchiveTasksComplete = createAction(
  '[Task] UnArchive Tasks Complete',
  props<{ updates: Update<TaskResponse>[] }>()
)

export const ChangeTasksStatus = createAction(
  '[Task] Change Tasks Status',
  props<{ status: TaskStatus; ids: string[] }>()
)
export const ChangeTasksStatusComplete = createAction(
  '[Task] Change Tasks Status Complete',
  props<{ update: Update<TaskResponse>[] }>()
)
